/**
 * Shared react-select theme override that maps the library's internal
 * `primary*` color slots onto the LedgerLoop brand green
 * (styles.css: --primary = #44814E + --rgba-primary-{1..3}). Without this,
 * react-select renders focus rings, selection backgrounds and option
 * highlights in its default #2684FF blue, which clashes with every other
 * focus state in the app.
 *
 * Use:
 *   import Select from 'react-select';
 *   import { brandSelectTheme } from '.../Common/reactSelectTheme';
 *   <Select ... theme={brandSelectTheme} />
 *
 * If a call site needs to compose additional `styles` overrides, pass
 * them via the `styles` prop as usual — this helper only touches the
 * theme/colors object.
 *
 * Why hex literals instead of `var(--primary)`: react-select substitutes
 * these values into inline `style` attributes (e.g. on the focused
 * option's background), and some of those slots aren't reliably
 * computed-property-friendly across browsers. Keeping the resolved
 * values here matches `:root { --primary: #44814E }` in styles.css —
 * if those vars ever change, update this file in the same commit.
 */
export const brandSelectTheme = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary: '#44814E',                    // var(--primary)
    primary75: 'rgba(68, 129, 78, 0.30)',  // var(--rgba-primary-3)
    primary50: 'rgba(68, 129, 78, 0.20)',  // var(--rgba-primary-2)
    primary25: 'rgba(68, 129, 78, 0.10)',  // var(--rgba-primary-1)
  },
});
